import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import SnackbarMessage from "components/SnackbarMessage";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import { useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ISaveProduct, SaveProduct } from "services/KnowfullyAdminClient";
import { SnackbarMessageProps } from "types/common-types";
import translateError from "utils/translateError";
import ProductForm from "./ProductForm";
import useTitle from "hooks/useTitle";

export default function ProductCreatePage() {
  const { formatMessage: t } = useIntl();
  const { productsUrl, productDetailsUrl, productService } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  useTitle(t({ id: "newProduct" }));

  const onSubmit = async (values: ISaveProduct) => {
    try {
      const response = await productService.saveProduct(
        new SaveProduct(values)
      );

      queryClient.invalidateQueries("products");
      setSnackbarMessage(new SnackbarMessageProps(t({ id: "productCreated" })));
      navigate(productDetailsUrl(response.id));
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={productsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="newProduct" />
      </Typography>
      <ProductForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "productFormCreateButton" })}
        onCancel={() => navigate(productsUrl())}
      />

      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
}
